import { GET_SETTINGS_FAILURE } from "../store/settings/settings.types";
import { NotificationContext, Notificator } from "../components/notification";
import { LOGIN_FAILURE, logout } from "../pages/login/login.actions";
import { LOAD_INFO_FAILURE, WRONG_USER_MODE } from "../store/info/info.types";
import { LOAD_ATTRIBUTES_FAILURE } from "../store/attributes/attributes.types";
import { ACTIVATE_SERVICES_FAILURE } from "../store/account/account.types";

export const errorsMiddleware = ({ dispatch, getState }) => {
  return (next) => {
    return (action) => {
      const { account } = getState();

      switch (action.type) {
        case GET_SETTINGS_FAILURE: {
          dispatch(
            Notificator.error("settings_failed", {
              context: NotificationContext.System,
            })
          );
          break;
        }
        case ACTIVATE_SERVICES_FAILURE: {
          dispatch(
            Notificator.error("couldnt_activate_services", {
              context: NotificationContext.System,
            })
          );
          dispatch(logout());
          break;
        }
        case LOAD_ATTRIBUTES_FAILURE: {
          dispatch(
            Notificator.warning("language_load_error", {
              context: NotificationContext.System,
            })
          );
          break;
        }
        case LOGIN_FAILURE: {
          dispatch(
            Notificator.error("login_error", {
              context: NotificationContext.System,
            })
          );
          break;
        }
        case LOAD_INFO_FAILURE: {
          if (isUserLoggedIn(account)) {
            dispatch(
              Notificator.error("login_error", {
                context: NotificationContext.System,
              })
            );
          }
          break;
        }
        case WRONG_USER_MODE: {
          dispatch(
            Notificator.error("login_error", {
              context: NotificationContext.System,
            })
          );
          dispatch(logout());
          break;
        }
        default:
          break;
      }

      return next(action);
    };
  };
};

const isUserLoggedIn = (account) => account && account.id;
